import React from 'react';
import useStore from './../store';
import {generateUUID} from 'three/src/math/MathUtils';
import {dummyAsins} from '../testData/asins';
import StringDispenser from '../hooks/StringDispenser';
import {JazeemInventoryEvent} from "src/API";
import 'react-toastify/dist/ReactToastify.css';
import {LIVE} from "src/globalVariables/globalVariables";


function DevModeButtons() {

  const addInventoryEvent = useStore(state => state.addInventoryEvent);
  const getDummyAsin = StringDispenser(dummyAsins);

  return (
      <>
          <button
              data-testid="checkout-button"
              onClick={() => {
                  addInventoryEvent({
                      asin: getDummyAsin(),
                      storeId: 'US-WA-2186',
                      process: 'checkout',
                      eventId: generateUUID(),
                      timestamp: new Date().toISOString(),
                  } as JazeemInventoryEvent, LIVE);
              }}>Fresh Event
          </button>
          <button
              data-testid="checkout-button2"
              onClick={() => {
                  addInventoryEvent({
                      asin: getDummyAsin(),
                      storeId: 'US-NC-3',
                      process: 'checkout',
                      eventId: generateUUID(),
                      timestamp: new Date().toISOString(),
                  } as JazeemInventoryEvent, LIVE);
              }}>WFM Event
          </button>
      </>
  );
}

export default DevModeButtons;
